import { createFileRoute } from '@tanstack/react-router';

// relative imports
import ReportsPageContainer from '../../components/reports/ReportsPageContainer';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/reports')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ReportsPageContainer,
  staticData: {
    configPageId: 'reports',
    meta: {
      title: 'Reports | Ledgible',
    },
  },
});
